/**
 * Copyright © 2025 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

const apiHeaders = {
    "Content-Type": "application/json",
     "Cache-Control": "no-cache, no-store, must-revalidate",
     "Pragma": "no-cache",
     "Expires": "0",
     "X-Frame-Options": "DENY", // Prevents clickjacking attacks
     "X-XSS-Protection": "1; mode=block", // Protects against reflected XSS attacks
     "X-Content-Type-Options": "nosniff", // Prevents MIME-type sniffing
     "Referrer-Policy": "strict-origin-when-cross-origin", // Limits sensitive referrer info
     "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload" // Enforces HTTPS
};

export default apiHeaders;
